import { render, staticRenderFns } from "./Shylock1Dialog.vue?vue&type=template&id=4f6320d4&scoped=true"
import script from "./Shylock1Dialog.vue?vue&type=script&lang=js"
export * from "./Shylock1Dialog.vue?vue&type=script&lang=js"
import style0 from "./Shylock1Dialog.vue?vue&type=style&index=0&id=4f6320d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6320d4",
  null
  
)

export default component.exports